export const ArticleCardData = {
    title:"Buch statt Bildschirm?",
    description:"Die Digitalisierungsskepsis nimmt in Skandinaviens bildungspolitischen Debatten immer mehr Raum ein. Innerhalb und außerhalb der Parlamente wird etwa in Dänemark, Schweden und Norwegen diskutiert: Wie sieht ein altersgerechter Einsatz digitaler Medien aus? Grundtenor: weniger Bildschirmzeit, mehr Lesezeit im gedruckten Buch.",
    photo:"/ArticleCardImage.png?854",
    redirect_url:"/room-post/239/854",
    organization:{id:314, photo:"/table-bildung.png"},
    postId:851
}